var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAqaMarkLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 405.21,
    height: 123.801,
    viewBox: "0 0 405.21 123.801",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1265",
    "data-name": "Group 1265",
    transform: "translate(-757.323 -290.329)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1248",
    "data-name": "Group 1248",
    transform: "translate(778.182 290.329)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1244",
    "data-name": "Group 1244",
    transform: "translate(303.122 25.97)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2421",
    "data-name": "Path 2421",
    d: "M1219.073,980.5l-7.271,11.7,47.219,80.418h13.546Z",
    transform: "translate(-1211.801 -980.497)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_2422",
    "data-name": "Path 2422",
    d: "M948.913,985.564l-14.4.14,37.244,62.284h13.546l-16.855-28.911a57.881,57.881,0,0,0,7.462-21.138,59.02,59.02,0,0,0-11.594-44.718,57.7,57.7,0,0,0-17.1-15.1,59.287,59.287,0,0,0-81.171,21.046,59.375,59.375,0,0,0-7.611,21.508,59.023,59.023,0,0,0,11.594,44.717A59.161,59.161,0,0,0,932.1,1046.72a58.928,58.928,0,0,0,21.159-10.266c.652-.5,1.282-1.028,1.908-1.556l-6.409-10.782a46.986,46.986,0,1,1,13.856-46.631,44.918,44.918,0,0,1-1.656,28.742Z",
    transform: "translate(-736.368 -929.902)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2423",
    "data-name": "Path 2423",
    d: "M1144.566,944.172l6.866,12.395-57.428,97.9h-13.546Z",
    transform: "translate(-844.753 -936.847)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1245",
    "data-name": "Group 1245",
    transform: "translate(67.417 25.97)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2424",
    "data-name": "Path 2424",
    d: "M776.634,980.5l-7.272,11.7,47.22,80.418h13.546Z",
    transform: "translate(-769.362 -980.497)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_2425",
    "data-name": "Path 2425",
    d: "M702.127,944.172l6.866,12.395-57.428,97.9H638.019Z",
    transform: "translate(-638.019 -936.847)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAqaMarkLogo);
export default __webpack_public_path__ + "static/media/aqa-mark-logo.61a64c31feb1fe635b8273f5b9ac4b47.svg";
export { ForwardRef as ReactComponent };